import script from "./ChatContextBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatContextBar.vue?vue&type=script&setup=true&lang=js"

import "./ChatContextBar.vue?vue&type=style&index=0&id=dea723ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dea723ae"]])

export default __exports__